import { PanelEditorScope } from "../panels/panel-editor-scope";
import { PanelLouvrePropertiesDockingPanelContent } from "./content/panelLouvrePropertiesDockingPanelContent";
import { DockingPanel } from "./dockingPanel";

export class PanelLouvrePropertiesDockingPanel {
    private readonly panel: DockingPanel;
    private visible: boolean;

    constructor(container: HTMLElement, panelEditorScope: PanelEditorScope) {
        this.visible = false;

        const component = <PanelLouvrePropertiesDockingPanelContent panelEditorScope={panelEditorScope} />;

        this.panel = new DockingPanel(
            container,
            "dextall-studio-panel-louvre-properties",
            "Louvre",
            component,
            {
                style: {
                    resize: "both",
                },
                dimensionsControl: {
                    preventOverlapsWithViewerToolbar: true,
                    widthDimensionControl: { value: 360, minValue: 360 },
                    heightDimensionControl: { value: 500, minValue: 500 },
                    topOffset: 2,
                    leftOffset: 364, // Positioned next to the Panel properties docking panel
                },
            },
        );

        this.panel.addVisibilityListener((x: boolean) => (this.visible = x));
    }

    setVisible(visibility: boolean) {
        if (this.visible === visibility) {
            return;
        }
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }
}
